module.exports = __webpack_public_path__ + "img/top.171afd8.png";